import { Injectable } from '@angular/core';

import type { TopicCombination } from '../models';

export interface WritingSessionState {
  selectedCombination: TopicCombination;
  answers: string[];
}

@Injectable({ providedIn: 'root' })
export class WritingSessionService {
  private readonly storageKey = 'writingSession';

  getSession(): WritingSessionState | null {
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return null;
      const parsed = JSON.parse(raw) as WritingSessionState;
      if (!parsed.selectedCombination || !Array.isArray(parsed.answers)) return null;
      return parsed;
    } catch {
      return null;
    }
  }

  saveSession(selectedCombination: TopicCombination, answers: string[]): void {
    const payload: WritingSessionState = {
      selectedCombination,
      answers: [...answers]
    };
    localStorage.setItem(this.storageKey, JSON.stringify(payload));
  }

  updateAnswers(answers: string[]): void {
    const session = this.getSession();
    if (!session) return;
    this.saveSession(session.selectedCombination, answers);
  }

  clearSession(): void {
    localStorage.removeItem(this.storageKey);
  }

  isSameCombination(
    left: TopicCombination | null | undefined,
    right: TopicCombination | null | undefined
  ): boolean {
    if (!left || !right) return false;
    return (
      left.year === right.year &&
      left.month === right.month &&
      left.combinationNumber === right.combinationNumber
    );
  }
}
